import { Button, PageHeader } from 'components';
import { Form, Row, Col } from 'antd';
import styles from './style.module.scss';
import { CheckOutlined, EyeOutlined } from '@ant-design/icons';
import InfoSection from './formSections/info';
import FileSection from './formSections/file';
import { useTranslation } from 'react-i18next';

import useUserVacancies from '../useUserVacancies';
import UIHelper from '../../../../../helpers/UIHelper';
import { Link, useLocation } from 'react-router-dom';

const Edit = ({ isNew }) => {
  const { t } = useTranslation();
  const {
    form,
    data,
    handleCreateOrUpdateShop,
    shoppingCenters,
    updateInProcess,
    singleItem,
  } = useUserVacancies(false, !isNew);
  const { pathname } = useLocation();
  const onFinish = async (values) => {
    await handleCreateOrUpdateShop(values);
  };

  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };

  const onClickSave = () => {
    form.submit();
  };

  const title = isNew ? t('Adesione privacy') : t('MODIFICA Adesione privacy');

  return (
    <div>
      <PageHeader title={title} />
      <div className={styles.content}>
        <Form
          form={form}
          name='basic'
          wrapperCol={{
            span: 24,
          }}
          initialValues={{
            doc: [],
            shopping_center_id: '',
          }}
          layout={'vertical'}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          autoComplete='off'
        >
          <InfoSection outletVillages={shoppingCenters} />
          <FileSection isEdit={!isNew} singleItem={singleItem} />
        </Form>
        <Row gutter={16}>
          <Col>
            <Button
              onClick={onClickSave}
              width={'150px'}
              big
              icon={<CheckOutlined />}
            >
              {t('Invia')}
            </Button>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default Edit;
